import moment from "moment";

export const currentEpochSeconds = () => {
  return moment.utc().unix();
};

export const unixTimeFormatter = (unixTime, format) => {
  return moment.unix(unixTime).format(format);
};

export const isBefore = (date, target, granularity) => {
  if (date) {
    return moment(date).isBefore(target, granularity);
  }
  return null;
};

export const formatter = (target, format) => {
  return moment(target, format);
};

export const toMomentObj = date => {
  if (date) {
    return moment(date);
  }
  return null;
};

export const addTime = (date, amount, unit) => {
  if (date) {
    return moment(date).add(amount, unit);
  }
  return null;
};

export const endOf = (target, unit) => {
  if (target) {
    return moment(target).endOf(unit);
  }
  return null;
};

export const toLocalDateTime = date => {
  if (date) {
    return moment(date).format("YYYY-MM-DD 00:00:00");
  }
  return null;
};

export const toYMDHm = date => {
  if (date) {
    return moment(date).format("YYYY-MM-DD HH:mm");
  }
  return null;
};

export const toYMDHm_jp = date => {
  if (date) {
    return moment(date).format("YYYY年MM月DD日 HH:mm");
  }
  return null;
};

export const timestampToYMDHm_jp = timestamp => {
  if (timestamp) {
    return moment(timestamp, "X").format("YYYY年MM月DD日 HH:mm");
  }
  return null;
};

export const toYMD = (date, format) => {
  if (date) {
    let _format = format === null ? "YYYY-MM-DD" : format;
    return moment(date).format(_format);
  }
  return null;
};

export const calendar_ja = date => {
  if (date) {
    return new Intl.DateTimeFormat("ja-JP-u-ca-japanese", {
      era: "long",
      year: "numeric"
    }).format(date);
  }
  return null;
};

export const toYMD_ja = date => {
  if (date) {
    return moment(date).format("YYYY年MM月DD日");
  }
  return null;
};

export const toDate = string => {
  if (string) {
    return moment(string).toDate();
  }
  return null;
};

export const toEMD_ja = date => {
  if (date) {
    const result = new Intl.DateTimeFormat("ja-JP-u-ca-japanese", {
      era: "long",
      year: "numeric",
      month: "long",
      day: "numeric"
    }).format(date);
    return result;
  }
  return null;
};

export const subtractMonthFromToday = months => {
  if (months) {
    return moment().subtract(months, "months");
  }
  return null;
};

export const diffSec = (to, from) => {
  return from.diff(to, "seconds");
};

export const diff = (to, from, unit) => {
  return moment(from).diff(moment(to), unit);
};

export const diffDays = targetDate => {
  if (targetDate) {
    return moment().diff(targetDate, "days");
  }
  return null;
};

export const diffHoursToFrom = (to, from) => {
  return from.diff(to, "hours");
};

export const isBetween2 = (targetDate, from, to) => {
  return targetDate.isBetween(from, to, null, "[]");
};

export const isBetween = (targetDate, from, to) => {
  return moment(targetDate).isBetween(moment(from), moment(to), null, "[]");
};

export const isOverTime = (to, from, unit) => {
  let momentTo = moment(to);
  let momentFrom = moment(from);
  return 0 !== momentFrom.diff(momentTo, unit);
};

export const toHmsFromSec = (t, formatColon) => {
  let hms = "";
  let h = (t / 3600) | 0;
  let m = ((t % 3600) / 60) | 0;
  let s = t % 60;

  if (formatColon) {
    if (h !== 0) {
      hms = h + ":" + padZero(m) + ":" + padZero(s);
    } else if (m !== 0) {
      hms = padZero(m) + ":" + padZero(s);
    } else {
      hms = "00:" + padZero(s);
    }
  } else {
    if (h !== 0) {
      hms = h + "時間" + padZero(m) + "分" + padZero(s) + "秒";
    } else if (m !== 0) {
      hms = m + "分" + padZero(s) + "秒";
    } else {
      hms = s + "秒";
    }
  }

  return hms;

  function padZero(v) {
    if (v < 10) {
      return "0" + v;
    } else {
      return v;
    }
  }
};

export const elapsedTimeByTimestamp = timestamp => {
  return elapsedTime(moment(Math.floor(timestamp / 1000), "X").format());
};

export const elapsedTime = startTime => {
  let x = new Date(startTime);
  let now = new Date();
  let timeDiff = now - x;
  timeDiff /= 1000;

  let seconds = Math.round(timeDiff);
  timeDiff = Math.floor(timeDiff / 60);

  let minutes = Math.round(timeDiff % 60);
  timeDiff = Math.floor(timeDiff / 60);

  let hours = Math.round(timeDiff % 24);
  timeDiff = Math.floor(timeDiff / 24);

  let days = Math.round(timeDiff % 365);
  timeDiff = Math.floor(timeDiff / 365);

  let years = timeDiff;

  if (years > 0) {
    return years + (years > 1 ? "年" : "年") + "前";
  } else if (days > 0) {
    return days + (days > 1 ? "日" : "日") + "前";
  } else if (hours > 0) {
    return hours + (hours > 1 ? "時間" : "時間") + "前";
  } else if (minutes > 0) {
    return minutes + (minutes > 1 ? "分" : "分") + "前";
  } else if (seconds > 0) {
    return seconds + (seconds > 1 ? "秒" : "秒") + "前";
  } else {
    return "たった今";
  }
};

export const elapsedTimeWithMinimumUnitMinute = (startTime) => {
  let x = new Date(startTime);
  let now = new Date();
  let timeDiff = now - x;
  timeDiff /= 1000;

  timeDiff = Math.floor(timeDiff / 60);

  let minutes = Math.round(timeDiff % 60);
  timeDiff = Math.floor(timeDiff / 60);

  let hours = Math.round(timeDiff % 24);
  timeDiff = Math.floor(timeDiff / 24);

  let days = Math.round(timeDiff % 365);
  timeDiff = Math.floor(timeDiff / 365);

  let years = timeDiff;

  if (years > 0) {
    return years + "年前";
  } else if (days > 0) {
    return days + "日前";
  } else if (hours > 0) {
    return hours + "時間前";
  } else if (minutes > 0) {
    return minutes + "分前";
  } else {
    return "1分以内";
  }
};

export const rounding30min = target => {
  let res;
  let mm = Number(target.split(":")[1]);
  if (mm >= 30) {
    res = `${target.split(":")[0]}:30:00`;
  } else {
    res = `${target.split(":")[0]}:00:00`;
  }
  return res;
};

export const rounding10min = target => {
  let res;
  let mm = Number(target.split(":")[1]);
  if (mm <= 9) {
    res = `${target.split(":")[0]}:00`;
  } else {
    let ten = String(mm).charAt(0);
    res = `${target.split(":")[0]}:${ten}0`;
  }
  return res;
};


export const roundingUp10min = target => {
  let res;
  let mm = Number(target.split(":")[1]);
  if (mm <= 9) {
    res = `${target.split(":")[0]}:00`;
  } else {
    let tenStr = String(mm).charAt(0);
    let ten = Number(tenStr) + 1
    res = `${target.split(":")[0]}:${ten}0`;
  }
  return res;
};

export default {
  formatter,
  unixTimeFormatter,
  currentEpochSeconds,
  toMomentObj,
  addTime,
  endOf,
  toLocalDateTime,
  toYMDHm,
  toYMDHm_jp,
  timestampToYMDHm_jp,
  toYMD,
  toYMD_ja,
  toDate,
  toEMD_ja,
  subtractMonthFromToday,
  diff,
  diffSec,
  diffDays,
  diffHoursToFrom,
  isBetween,
  toHmsFromSec,
  elapsedTime,
  elapsedTimeByTimestamp,
  elapsedTimeWithMinimumUnitMinute,
  calendar_ja,
  isBefore,
  isOverTime,
  rounding30min,
  rounding10min,
  roundingUp10min
};
